import { render, staticRenderFns } from "./PriceDisplay.vue?vue&type=template&id=182f24f1&scoped=true"
import script from "./PriceDisplay.vue?vue&type=script&lang=js"
export * from "./PriceDisplay.vue?vue&type=script&lang=js"
import style0 from "./PriceDisplay.vue?vue&type=style&index=0&id=182f24f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f24f1",
  null
  
)

export default component.exports